<form [formGroup]="BdsControl" (submit)="submitData()">
<h1>Assigned Bds<button type="button" (click)="CloseModal()" class="btn btn-default float-right"><i class="fa fa-times" aria-hidden="true"></i></button></h1>
<mat-form-field class="customform" floatLabel="never">
    
    <mat-label>Select BDs</mat-label>
    <mat-select [formControl]="BdsControl" multiple class="custom_matselect" [compareWith]="compareFn" [(ngModel)]="selectedObjects">
  
      <mat-select-trigger>
        <mat-chip-list>
          <mat-chip *ngFor="let bdobj of BdsControl.value;"
            [removable]="true" (removed)="onToppingRemoved(bdobj)" [selectable]="selectable">
            {{ bdobj.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </mat-select-trigger>
  
      <mat-option *ngFor="let bd of bds" [value]="bd">{{bd.name}}</mat-option>
  
    </mat-select>
    <div class="col-sm-12 spinner_loader" *ngIf="spinner_loader"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
    <!-- <div *ngIf="submitted && BdsControl.errors" class="invalid-feedback">
        <div *ngIf="BdsControl.errors.required">Please select atleast one Bd</div>
    </div> -->

  </mat-form-field>
  <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Submit</button>
  
</form>

